import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserAuthenticationService } from '../../services/user-authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  private readonly userAuthenticationService = inject(UserAuthenticationService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  returnUrl: string = '/dashboard';

  isLoading = false;
  showPassword = false;
  wrongCredentials = false;
  username: FormControl<string | null> = new FormControl('', Validators.required);
  password: FormControl<string | null> = new FormControl('', Validators.required);

  ngOnInit(): void {
    if (this.userAuthenticationService.isUserAuthenticated) {
      this.router.navigate([this.returnUrl]);
    }

    const routeReturn = this.route.snapshot.queryParamMap.get('returnUrl');
    if (routeReturn) {
      this.returnUrl = routeReturn;
    }
  }

  loginFormGroup: FormGroup = new FormGroup({
    username: this.username,
    password: this.password,
  });

  login() {
    if (this.loginFormGroup.valid) {
      this.isLoading = true;
      const loginBody = {
        username: this.loginFormGroup.value.username,
        password: this.loginFormGroup.value.password,
      };
      this.userAuthenticationService.login(loginBody).subscribe((response) => {
        this.isLoading = false;
        if (response) {
          this.router.navigateByUrl(this.returnUrl);
        } else {
          this.wrongCredentials = true;
        }
      });
    }
  }
}
